import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../Navbar';
import Sidebar from './Sidebar';
import BottomNav from '../BottomNav';

const NAVBAR_HEIGHT = 64;
const SIDEBAR_WIDTH = 240;
const SIDEBAR_COLLAPSED_WIDTH = 64;

const MainLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const [sidebarCollapsed, setSidebarCollapsed] = useState(isTablet);

  const location = useLocation();
  // Pages that should fill edge-to-edge with no padding (manage their own scroll)
  const isFullBleed = location.pathname === '/chat';

  const handleToggle = () => setSidebarCollapsed(p => !p);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
        bgcolor: '#F4F8F4',
      }}
    >
      {/* Top Navbar — position:fixed, so add an explicit spacer below it */}
      <Navbar onMenuClick={handleToggle} height={NAVBAR_HEIGHT} />
      <Box sx={{ height: NAVBAR_HEIGHT, flexShrink: 0 }} />

      {/* Content row: fills 100vh − NAVBAR_HEIGHT exactly */}
      <Box sx={{ display: 'flex', flex: 1, minHeight: 0, overflow: 'hidden' }}>
        {/* Desktop Sidebar */}
        {!isMobile && (
          <Sidebar
            collapsed={sidebarCollapsed}
            onToggle={handleToggle}
            width={SIDEBAR_WIDTH}
            collapsedWidth={SIDEBAR_COLLAPSED_WIDTH}
          />
        )}

        {/* Main Content */}
        <Box
          component="main"
          sx={{
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            overflowY: isFullBleed ? 'hidden' : 'auto',
            overflowX: 'hidden',
            p: isFullBleed ? 0 : { xs: 2, sm: 2.5, md: 3 },
            pb: isFullBleed
              ? (isMobile ? `${NAVBAR_HEIGHT}px` : 0)
              : (isMobile ? 10 : 3),
            transition: 'all 0.28s cubic-bezier(0.4,0,0.2,1)',
            bgcolor: isFullBleed ? 'white' : '#F4F8F4',
          }}
        >
          <Outlet />
        </Box>
      </Box>

      {/* Mobile Bottom Navigation */}
      {isMobile && <BottomNav />}
    </Box>
  );
};

export default MainLayout;
